import React from 'react';
import StockReceptionForm from 'forms/StockReceptionForm';

export default (): JSX.Element => <StockReceptionForm />;
